interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
}

/** Compact mono prev/next pagination, designed to live inside <PageFooter right={...} />. */
export function Pagination({ page, pageSize, total, onPageChange, loading }: PaginationProps) {
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const canPrev = page > 1 && !loading;
  const canNext = page < lastPage && !loading;

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={!canPrev}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        ← prev
      </button>
      <span>
        page <b className="text-text-2">{page}</b> of <b className="text-text-2">{lastPage}</b>
      </span>
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={!canNext}
        className="hover:text-text disabled:opacity-30 disabled:cursor-not-allowed"
      >
        next →
      </button>
    </div>
  );
}
